import { ERROR_MODAL_CASES, SUCCESS_MODAL_CASES } from 'constants/order-states';

/**
 * Validate the cart status trying to get abstract meaningful information to update properly our app ui
 * @param {string} status - one of the states defined in order-states.js
 * @returns {object} result
 * @returns {boolean} result.isActive - true if the order is still active
 * @returns {boolean} result.isShipped - true if the order was shipped
 * @returns {boolean} result.isFailed -  true if the oder was canceled or not picked
 */
export default function getOrderState(status) {
    const isShipped = SUCCESS_MODAL_CASES.includes(status);
    const isFailed = ERROR_MODAL_CASES.includes(status);

    return {
        isActive: !isShipped && !isFailed,
        isShipped,
        isFailed,
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/get-order-state.js